export default "__VITE_ASSET__462f8005__"